import { type UseQueryResult, useQueries } from '@tanstack/react-query';
import {
  type CloudinaryFolder,
  type CloudinaryResult,
  getImageUrlsByFolder,
} from '@/services/cloudinary';

const MAX_RESULTS = 1;
const INITIAL_DATA: CloudinaryResult = {
  resources: [{ public_id: '', url: '', filename: '', tags: [] }],
};

interface GetImageUrlsByFoldersProperties {
  folders: CloudinaryFolder[];
  maxResults?: number;
  tags: string;
  hasFolders: boolean;
}

export default function useGetImageUrlsByFolders({
  folders = [],
  maxResults = MAX_RESULTS,
  tags,
  hasFolders = true,
}: GetImageUrlsByFoldersProperties): UseQueryResult<Record<string, string>>[] {
  return useQueries({
    queries: folders.map(({ path, name }) => ({
      enabled: !!path && hasFolders,
      initialData: INITIAL_DATA,
      queryFn: () =>
        getImageUrlsByFolder({
          folder: path,
          maxResults,
          tags,
        }),
      queryKey: ['get_image_urls_by_folders', maxResults, name, path, tags],
      select: (data: CloudinaryResult): Record<string, string> => ({
        [name]: data.resources[0].public_id,
      }),
    })),
  });
}
